import { select, Store } from '@ngrx/store';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ApplicationState } from '../../../../store/application-store';
import { Observable } from 'rxjs';
import { Profile } from '../../../../profiles/models/profile';
import * as profileActions from '../../../../profiles/actions/profiles';
import * as profileSeclectors from '../../../../profiles/selectors/profiles';
import { ProfileEditorComponent } from '../profile-editor.component/profile-editor.component';
import * as ProfileTypes from '../../../../profiles/models/profile-types';
import { WidgetConfiguration } from '../../../../widget-configs/models/widget-configuration';
import * as widgetConfigurationSelectors from '../../../../widget-configs/selectors/widget-configs';
import * as widgetConfigActions from '../../../../widget-configs/actions/widget-configs';
import { RouteContextService } from '../../../../context/services/route-context.service';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '../../../../profiles/services/profile.service';
import { MojoWellKnownNames }  from '../../../../common/constants/mojo-well-known-names';
import { ProductService } from '../../../../common/services/product.service';
import { takeWhile } from 'rxjs';

@Component({
  selector: 'mojo-profile-config-page',
  templateUrl: './profile-and-dashboard-configuration-page.component.html',
})
export class ProfileAndDashboardConfigPageComponent implements OnInit, OnDestroy {

  pageTitle$: Observable<string>;
  isAlive: boolean = true;
  dialogTitle: string;
  profiles$: Observable<Profile[]>;
  loading$: Observable<boolean>;
  widgetConfigurations$: Observable<WidgetConfiguration[]>;
  @ViewChild(ProfileEditorComponent, { static: true }) profileEditor;
  editorDialogTitle: string;

  ngOnInit() {
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  isStandardType(profile: Profile) {
    return profile.type === ProfileTypes.Standard;
  }

  constructor(protected store: Store<ApplicationState>,
    private routeContextService: RouteContextService,
    private activatedRoute: ActivatedRoute,
    private profileService: ProfileService,
    private productService: ProductService) {
    const product = this.routeContextService.getProductFromRouteData(activatedRoute);
    this.profiles$ = this.profileService.getAllProfiles(product);
    this.store.dispatch(new widgetConfigActions.LoadAll(product));
    this.loading$ = this.store.pipe(select(profileSeclectors.selectLoading()));
    this.widgetConfigurations$ = this.store.pipe(select(widgetConfigurationSelectors.selectAll));
    this.setPageTitle();
  }

  profileSelected(selectedProfile: Profile) {
    this.showDialogToEdit(selectedProfile);
  }

  showDialogToAdd() {
    this.dialogTitle = 'New Profile';
    var newProfile = new Profile();
    newProfile.type = ProfileTypes.Custom;
    this.profileEditor.showDialog(newProfile, true /* Create New Profile */);
  }

  showDialogToEdit(profile: Profile) {
    this.dialogTitle = 'Edit Profile';
    this.profileEditor.showDialog(profile, false /* Dont Create New Profile */);
  }

  getDashboardDesignerPath(): string {
    return this.routeContextService.getDashboardDesignerPathFromRouteData(this.activatedRoute);
  }

  setPageTitle(): void {
    const product = this.routeContextService.getProductFromRouteData(this.activatedRoute);
    this.pageTitle$ = this.productService.currentProductTitle('Manage My Profiles', product);
  }

  loadProfiles() {
    this.store.dispatch(new profileActions.LoadAll(this.routeContextService.getProductFromRouteData(this.activatedRoute)));
  }

}
